export const isInIframe = (): boolean => window.location !== window.parent.location